import { useEffect } from 'react';
import { useResolvedTheme } from './useResolvedTheme';

/** Synchronizes app settings (like theme) to the DOM. */
export const useSettingsSync = () => {
  const resolvedTheme = useResolvedTheme();

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', resolvedTheme);
  }, [resolvedTheme]);
};
